import Affix from './Affix';

export type { AffixProps } from './Affix';

export { Affix };
export default Affix;
